





















import { DocumentImage, ServerStatus } from '@/types';
import Vue, { PropType } from 'vue';
export default Vue.extend({
  props: {
    value: Object as PropType<DocumentImage>,
    editable: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    // A persisted backend Document (service flow) carries an id and no library
    // media — it is already saved server-side.
    isPersisted(): boolean {
      return this.value.id != null && !this.value.media;
    },

    statusColor(): string {
      if (this.isPersisted) return 'success';

      if (!!this.value.media && !this.value.media.saved) return 'error';

      switch (this.value.serverStatus) {
        case 'available':
          return 'success';
        case 'missing':
          return 'error';
        default:
          return 'info';
      }
    },

    icon(): string {
      if (this.isPersisted) return 'mdi-cloud-check';

      if (!!this.value.media && !this.value.media.saved) return 'mdi-cloud-alert';

      switch (this.value.serverStatus) {
        case 'available':
          return 'mdi-cloud-check';
        case 'missing':
          return 'mdi-cloud-alert';
        default:
          return 'mdi-cloud-question';
      }
    },
  },
});
